/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '@components/common/locale/useLanguage';
import { LoadingSpinner } from '@components/frontStore/catalog/product/single/LoadingSpinner';
import DesktopMenu from './components/DesktopMenu';
import MobileMenu from './components/MobileMenu';
import ScrollToTopButton from './components/ScrollToTopButton';
import FloatingCart from './components/FloatingCart';
import BusyPopup from './components/BusyPopup';
import { useMenuData } from './hooks/useMenuData';
import { useScrollManagement } from './hooks/useScrollManagement';
import { useCategoryNavigation } from './hooks/useCategoryNavigation';
import './Menu.scss';
export default function Menu() {
  // const [showPopup, setShowPopup] = useState(true);
  var [showStoreStatus, setShowStoreStatus] = useState(true);
  var hasScrolledToHighlight = useRef(false);
  var {
    isAr
  } = useLanguage();
  var {
    loading,
    error,
    categories,
    collections,
    storeStatus
  } = useMenuData();
  var calculateBottom = () => {
    var footer = document.querySelector('.footer') || document.querySelector('main + div') || document.querySelector('footer');
    if (!footer) return '6rem';
    var footerRect = footer.getBoundingClientRect();
    var viewportHeight = window.innerHeight;
    var footerOverlap = viewportHeight - footerRect.top;
    if (footerOverlap > 0) {
      return "calc(6rem + ".concat(footerOverlap, "px)");
    }
    return '6rem';
  };
  var [bottomOffset, setBottomOffset] = useState('6rem');
  useEffect(() => {
    var handleScroll = () => {
      setBottomOffset(calculateBottom());
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    window.addEventListener('resize', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);
  var scrollManagement = useScrollManagement(categories);
  var {
    showScrollButton,
    selectedCategory,
    setSelectedCategory,
    navRef,
    scrollableContentRef,
    isScrollingProgrammatically,
    scrollTimeout,
    scrollToTop,
    setCategoryRef
  } = scrollManagement;
  var {
    handleCategorySelect: _handleCategorySelect
  } = useCategoryNavigation(setSelectedCategory, isScrollingProgrammatically, scrollTimeout);

  // Handle URL highlight parameter - only once on mount
  useEffect(() => {
    if (categories.length === 0 || hasScrolledToHighlight.current) return;
    var urlParams = new URLSearchParams(window.location.search);
    var highlightCategory = urlParams.get('highlight');
    if (highlightCategory) {
      hasScrolledToHighlight.current = true;
      setSelectedCategory(highlightCategory);
      setTimeout(() => {
        var categoryId = "mobile-category-".concat(highlightCategory.toLowerCase().replace(/\s+/g, '-'));
        var element = document.getElementById(categoryId);
        if (element) {
          if (window.innerWidth < 768) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          } else {
            _handleCategorySelect(highlightCategory, scrollableContentRef);
          }
        }
      }, 300);
    }
  }, [categories, setSelectedCategory, _handleCategorySelect, scrollableContentRef]);

  // Scroll listeners are now managed internally by the useScrollManagement hook

  // Desktop wheel event handler
  useEffect(() => {
    var handleWheelEvent = e => {
      if (window.innerWidth < 768 || !scrollableContentRef.current || document.body.classList.contains('modal-open')) {
        return;
      }
      var scrollable = scrollableContentRef.current;
      var {
        scrollTop,
        scrollHeight,
        clientHeight
      } = scrollable;
      var pageScrollY = window.scrollY || document.documentElement.scrollTop;
      if (e.deltaY > 0) {
        // Scrolling Down: hijack to scroll inner content panel
        if (scrollTop + clientHeight < scrollHeight - 1) {
          e.preventDefault();
          scrollable.scrollTop += e.deltaY;
        }
        // When at bottom, don't prevent default so page can scroll to footer
      } else if (e.deltaY < 0) {
        // Scrolling Up
        if (pageScrollY > 0) {
          // Footer visible — scroll page up to hide footer first
          e.preventDefault();
          window.scrollBy(0, e.deltaY);
        } else if (scrollTop > 0) {
          // Page at top — scroll inner content up
          e.preventDefault();
          scrollable.scrollTop += e.deltaY;
        }
      }
    };
    window.addEventListener('wheel', handleWheelEvent, {
      passive: false
    });
    return () => window.removeEventListener('wheel', handleWheelEvent);
  }, [scrollableContentRef]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "loading"
    }, /*#__PURE__*/React.createElement(LoadingSpinner, null));
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "error"
    }, "Error loading menu:", ' ', typeof error === 'string' ? error : JSON.stringify(error));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, storeStatus === '0' && showStoreStatus && /*#__PURE__*/React.createElement(BusyPopup, {
    onClose: () => setShowStoreStatus(false)
  }), /*#__PURE__*/React.createElement("div", {
    className: "md:grid hidden"
  }, /*#__PURE__*/React.createElement(DesktopMenu, {
    categories: categories,
    collections: collections,
    storeStatus: storeStatus,
    selectedCategory: selectedCategory,
    handleCategorySelect: cat => _handleCategorySelect(cat, scrollableContentRef),
    scrollableContentRef: scrollableContentRef,
    setCategoryRef: setCategoryRef
  })), /*#__PURE__*/React.createElement("div", {
    className: "md:hidden"
  }, /*#__PURE__*/React.createElement(MobileMenu, {
    categories: categories,
    collections: collections,
    storeStatus: storeStatus,
    selectedCategory: selectedCategory,
    handleCategorySelect: _handleCategorySelect,
    navRef: navRef,
    setCategoryRef: setCategoryRef
  })), /*#__PURE__*/React.createElement("div", {
    className: "fixed flex flex-col items-center gap-6 z-[91] pointer-events-none",
    style: {
      bottom: bottomOffset,
      right: isAr ? 'auto' : '1rem',
      left: isAr ? '1rem' : 'auto'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative pointer-events-auto"
  }, /*#__PURE__*/React.createElement(FloatingCart, {
    setting: {
      storeStatus
    }
  }), showScrollButton && /*#__PURE__*/React.createElement(ScrollToTopButton, {
    onClick: scrollToTop
  }))));
}
;